import { Collapse, Text } from 'components';
import React from 'react';

const Instructions: React.FC = () => (
  <Collapse>
    <Collapse.Panel header="Instructions" key="1">
      <Text>
        1. First you can select a mlsType.
        <br />
        <br />
        2. Then, if you have prepared some OIDs, you can type in them separate
        by comma.
        <br />
        <br />
        3. At least a mlsType needs to be selected or some OIDs need to be
        provided. The more data you&apos;re going to process, the longer it will
        take to run the cron job. For bigger MLS e.g. TREB, we{' '}
        <b>strongly recommend to also provide OIDs</b>, to avoid the situation
        that the cron runs too long and this tools will time out. If no oids are
        provided, the cron for that mls will be triggered but the qa page will
        not be able to show you how many offices have been updated.
        <br />
        <br />
        4. As the amount of new data to process differs in a day from the first
        cron job to the following ones, you can choose &quot;Process&quot; to
        process all the new data, or &quot;Process From Last Hour&quot; to only
        process the data updated in the past hour.
        <br />
        <br />
      </Text>
    </Collapse.Panel>
  </Collapse>
);

export default Instructions;
